import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

export const SWIPER = {
  init: function () {
    const hero = document.querySelector('.js-swiper-hero')
    if (!hero) return

    /* eslint-disable no-unused-vars */

    const swiper = new Swiper('.js-swiper-hero .swiper', {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      loopAdditionalSlides: 1,
      speed: 2000,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      followFinger: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
    })

    /* eslint-enable no-unused-vars */
  },
}
